
export const parseHtml = (htmlText) => {
  try {
    if (typeof window.DOMParser != null) {
      let parser = new DOMParser();
      return parser.parseFromString(htmlText, "text/html");
    } else {
      // older IE
      let doc = document.implementation.createHTMLDocument('');
      doc.write(htmlText);
      doc.close();
      return doc;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

export const extractAppendices = (htmlText) => {

  let doc = parseHtml(htmlText);
  if (doc == null) {
    return [];
  }
  let res = [];
  let id;
  let nl = doc.getElementsByName("Appendix");
  let title;
  let ch;
  for (let ii = 0; ii < nl.length; ii++) {
    ch = nl[ii].children;
    if (ch.length > 0 && ch[0].innerHTML) {
      title = ch[0].innerHTML;
    } else if (nl && nl.innerHTML) {
      title = nl.innerHTML;
    } else {
      title = null;
    }
    if (title) {
      id = "Appendix_" + ii;
      nl[ii].id = id;
      res.push({id: id, title: title, isSubItem: true});
    }
  }
  let styles = doc.getElementsByTagName("STYLE");

  if (styles && styles.length && doc.body) {
    let style = styles[0];
    //make header styles not impact other headers in the page
    style.innerHTML = ''
    doc.body.insertBefore(style, doc.body.firstChild);
  }
  return [res, doc.body ? doc.body.innerHTML : null];
};

export const slugify = (string) => {
  let a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  let b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  let p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, function (c) {
        return b.charAt(a.indexOf(c));
      }) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with 'and'
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
}
